import { c as _c } from "react/compiler-runtime";
import React from "react";
import DropPartMarkdownWithPropLogger from "@/components/drops/view/part/DropPartMarkdownWithPropLogger";
import WaveDropQuoteWithDropId from "./WaveDropQuoteWithDropId";
import EditDropLexical from "./EditDropLexical";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import type { ApiDropReferencedNFT } from "@/generated/models/ApiDropReferencedNFT";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
import type { ApiDrop } from "@/generated/models/ApiDrop";
interface WaveDropPartContentMarkdownProps {
  readonly mentionedUsers: Array<ApiDropMentionedUser>;
  readonly mentionedWaves: Array<ApiMentionedWave>;
  readonly referencedNfts: Array<ApiDropReferencedNFT>;
  readonly part: ApiDropPart;
  readonly wave: ApiWaveMin;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly drop?: ApiDrop | undefined; // Add drop to check for edited status
}
const WaveDropPartContentMarkdown: React.FC<WaveDropPartContentMarkdownProps> = t0 => {
  const $ = _c(32);
  const {
    mentionedUsers,
    mentionedWaves,
    referencedNfts,
    part,
    wave,
    onQuoteClick,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    drop
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  if (isEditing) {
    const t3 = part.content ?? "";
    let t4;
    if ($[0] !== onSave) {
      t4 = (content, mentions, waves) => {
        if (onSave) {
          onSave(content, mentions, waves);
        }
      };
      $[0] = onSave;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    let t5;
    if ($[2] !== onCancel) {
      t5 = () => {
        if (onCancel) {
          onCancel();
        }
      };
      $[2] = onCancel;
      $[3] = t5;
    } else {
      t5 = $[3];
    }
    let t6;
    if ($[4] !== isSaving || $[5] !== mentionedUsers || $[6] !== mentionedWaves || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== wave.id) {
      t6 = <EditDropLexical initialContent={t3} initialMentions={mentionedUsers} initialWaveMentions={mentionedWaves} waveId={wave.id} isSaving={isSaving} onSave={t4} onCancel={t5} />;
      $[4] = isSaving;
      $[5] = mentionedUsers;
      $[6] = mentionedWaves;
      $[7] = t3;
      $[8] = t4;
      $[9] = t5;
      $[10] = wave.id;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  const t3 = drop?.id;
  const t4 = drop?.hide_link_preview;
  let t5;
  if ($[12] !== mentionedUsers || $[13] !== mentionedWaves || $[14] !== onQuoteClick || $[15] !== part.content || $[16] !== referencedNfts || $[17] !== t3 || $[18] !== t4) {
    t5 = <DropPartMarkdownWithPropLogger mentionedUsers={mentionedUsers} mentionedWaves={mentionedWaves} referencedNfts={referencedNfts} partContent={part.content} onQuoteClick={onQuoteClick} currentDropId={t3} hideLinkPreviews={t4} />;
    $[12] = mentionedUsers;
    $[13] = mentionedWaves;
    $[14] = onQuoteClick;
    $[15] = part.content;
    $[16] = referencedNfts;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== drop) {
    t6 = drop?.updated_at && drop.updated_at !== drop.created_at && <div className="tw-mt-0.5 tw-text-[10px] tw-font-normal tw-leading-none tw-text-iron-500">(edited)</div>;
    $[20] = drop;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t5 || $[23] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== onQuoteClick || $[26] !== part.quoted_drop || $[27] !== wave) {
    t8 = part.quoted_drop?.drop_id && <div className="tw-mt-1.5"><WaveDropQuoteWithDropId dropId={part.quoted_drop.drop_id} partId={part.quoted_drop.drop_part_id} maybeDrop={part.quoted_drop.drop ? {
        ...part.quoted_drop.drop,
        wave
      } : null} onQuoteClick={onQuoteClick} /></div>;
    $[25] = onQuoteClick;
    $[26] = part.quoted_drop;
    $[27] = wave;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t7 || $[30] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
};
export default WaveDropPartContentMarkdown;